import { useDispatch } from '../use-dispatch/index';
export var useApplication = function useApplication(controller, options) {
  // getter to detect Turbolink preview
  Object.defineProperty(controller, 'isPreview', {
    get: function get() {
      return document.documentElement.hasAttribute('data-turbolinks-preview');
    }
  }); // getter to get the csrf token

  Object.defineProperty(controller, 'csrfToken', {
    get: function get() {
      return this.metaValue('csrf-token');
    }
  });
  useDispatch(controller, options);
  Object.assign(controller, {
    metaValue: function metaValue(name) {
      var element = document.head.querySelector("meta[name=\"".concat(name, "\"]"));
      return element && element.getAttribute('content');
    }
  });
};